import {PaymentCodeEnum, PayoutWebModel} from "capitalist-shared/src/finance/payments";
import {CurrencyCode} from "@/models/core/currency";

export class RussianCardsPaymentModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.RussianCards

  splitable = true

  options = {
    ...this.getOptions(),
    warningNoticeTemp: null,
    beneficiaryRequired: false,
    isFullnameRequired: false,
    isFullnameRequiredButOptional: false,
    limitsTextHtml: null
  }

  // how to fix this?
  values = {
    ...this.getValues(),
    cardNumber: '',
    fio: '',
    firstname: '',
    lastname: '',
    patronymic: ''
  }
}


export class Card2cardPaymentModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.Card2Card

  options = {
    ...this.getOptions(),
    warning_blocked: null,
    warningNoticeTemp: null,
    warning1_1: null,
    limitsTextHtml: null,
    isTemporarilyDisabled: false,
    isFullnameRequired: false,
    isFullnameRequiredButOptional: false
  }

  values = {
    ...this.getValues(),
    cardNumber: '',
    fio: '',
    firstname: '',
    lastname: '',
    patronymic: ''
  }
}


export class WorldcardsPaymentModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.Cards

  values = {
    ...this.getValues(),
    expirationDate: '',
    cardCurrency: CurrencyCode.USD
  }

  options = {
    ...this.getOptions(),
    countries: {},
    beneficiaryCountryRestrictionHtml: '',
    limitsAlertText: null,
    cardCurrencySupport: false,
    limitsData: null
  }

}

export class WorldcardsEurPaymentModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.WorldCardsEuro

  values = {
    ...this.getValues(),
    expirationDate: '',
    cardCurrency: CurrencyCode.EUR
  }

  options = {
    ...this.getOptions(),
    countries: {},
    beneficiaryCountryRestrictionHtml: '',
    limitsAlertText: null,
    cardCurrencySupport: false,
    limitsData: null
  }

  preSubmit() {
    this.values.cardCurrency = CurrencyCode.EUR;
  }

}

export class WorldcardsUsdPaymentModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.WorldCardsUsd

  values = {
    ...this.getValues(),
    expirationDate: '',
    cardCurrency: CurrencyCode.USD
  }

  options = {
    ...this.getOptions(),
    countries: {},
    beneficiaryCountryRestrictionHtml: '',
    limitsAlertText: null,
    cardCurrencySupport: false,
    limitsData: null
  }

  preSubmit() {
    this.values.cardCurrency = CurrencyCode.USD;
  }

}

export class UkrainianCardsPaymentModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.UkrainianCards

  options = {
    ...this.getOptions(),
    limitsAlertHtml: null
  }

}


export class UnionpayPaymentModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.UnionPay


}
